import { createMuiTheme } from "@material-ui/core";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#16c4ab"
    },
    secondary: {
      main: "#16c4ab"
    }, 
  },
  input: {
    color: "red"
  },
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: "#16c4ab"
      }
    },
    MuiPickersModal: {
      dialogActions: {
        color: "#16c4ab"
      },
      flatButton: {
        primaryTextColor: "#000000"
      },
    }
  },
});

export default theme;